var components
try {
  components = {
    filterBox: function () {
      return import(
        /* webpackChunkName: "components/filter-box/filter-box" */ "@/components/filter-box/filter-box.vue"
      )
    },
    articleItem: function () {
      return import(
        /* webpackChunkName: "components/article-item/article-item" */ "@/components/article-item/article-item.vue"
      )
    },
    empty: function () {
      return import(
        /* webpackChunkName: "components/empty/empty" */ "@/components/empty/empty.vue"
      )
    },
    uLoadmore: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-loadmore/u-loadmore" */ "uview-ui/components/u-loadmore/u-loadmore.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = _vm.list && _vm.list.length > 0
  var g1 = _vm.list && _vm.list.length > 0
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        g1: g1,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }